var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "childFormRef",
          staticClass: "company-info_form",
          attrs: {
            inline: false,
            model: _vm.childForm,
            "label-width": _vm.getIsMobile ? "0" : "120px",
            "label-position": _vm.getIsMobile ? "top" : "right",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "是否含税", prop: "hs" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.hs,
                    callback: function ($$v) {
                      _vm.hs = $$v
                    },
                    expression: "hs",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("含税")]),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("未税")]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", "margin-bottom": "10px" },
                  attrs: { data: _vm.modelList, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "品牌", align: "center " },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: { placeholder: "请输入品牌" },
                              model: {
                                value: scope.row.source,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "source", $$v)
                                },
                                expression: "scope.row.source",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "型号", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: { placeholder: "请输入型号" },
                              model: {
                                value: scope.row.xhname,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "xhname", $$v)
                                },
                                expression: "scope.row.xhname",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "数量", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: { placeholder: "请输入数量" },
                              model: {
                                value: scope.row.num,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "num", $$v)
                                },
                                expression: "scope.row.num",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "单价", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: { placeholder: "请输入单价" },
                              model: {
                                value: scope.row.price,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "price", $$v)
                                },
                                expression: "scope.row.price",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "总价", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入总价",
                                readonly: "",
                                disabled: "",
                              },
                              model: {
                                value: scope.row.zprice,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "zprice", $$v)
                                },
                                expression: "scope.row.zprice",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "备注", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              attrs: { placeholder: "请输入备注" },
                              model: {
                                value: scope.row.bz,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "bz", $$v)
                                },
                                expression: "scope.row.bz",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "el-icon-delete",
                                attrs: { type: "danger", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleRemove(scope.$index)
                                  },
                                },
                              },
                              [_vm._v("删除 ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "el-icon-plus",
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.addModel },
            },
            [_vm._v("增加型号")]
          ),
          _c(
            "el-form-item",
            { staticClass: "model-editor", attrs: { label: "合同条款" } },
            [
              _c("div", {
                ref: "contractEditor",
                staticClass: "contractEditor",
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }